import React from "react";
import "./App.css";
import Survey from "./components/Survey";
import "bootstrap/dist/css/bootstrap.min.css";
import UrlNotValid from "./components/UrlNotValid";

import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div style={{ maxWidth: "600px" }} className="m-auto">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<UrlNotValid />} />

          <Route path="/s/:surveyId/:submitted" element={<Survey />} />
          <Route path="/s/:surveyId" element={<Survey />} />
          <Route path="*" element={<UrlNotValid />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
